<template>
	<div
		class="g-block-divider-dashed-sparse g-block-divider-padding"
		:class="{
			'g-block-divider-dashed-sparse--edit': editable,
			'is-active': editable && active,
			'g-block-divider-dashed-sparse--h5': h5,
			'g-block-divider-padding--h5': h5,
		}"
		@click="onWrapClick"
	>
		<span
			class="g-block-divider-dashed-sparse__line"
			:style="{ color: themeColor }"
			aria-hidden="true"
		></span>
	</div>
</template>

<script>
	import { dividerMixin } from '../shared/dividerMixin.js';

	export default {
		name: 'GBlockDividerDashedSparse',
		mixins: [dividerMixin],
	};
</script>

<style scoped lang="less">
	@import '../shared/dividerEditShell.less';
	@import '../shared/dividerPattern.less';

	.g-block-divider-dashed-sparse {
		.divider-block-edit-shell();
	}

	.g-block-divider-dashed-sparse__line {
		.divider-dash-line(1px, 14px, 8px);
	}

	.g-block-divider-dashed-sparse--h5 {
		.g-block-divider-dashed-sparse__line {
			.divider-dash-line--h5(0.02rem, 0.28rem, 0.16rem);
		}
	}
</style>
